import { Expose, Type } from "class-transformer";
import { USER_TYPE } from "@/static/userTypes";
import { IsArray, IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { UserOfficeProfile } from "@/models/api/administration/users/UserOfficeProfile";

export class UserBasicInfo {
  @Expose()
  @IsBoolean()
  isApproved!: boolean;
  @Expose()
  @IsBoolean()
  isLocked!: boolean;
  @Expose()
  @IsString()
  userName!: string;
  @Expose()
  @IsOptional()
  @IsString()
  friendlyName!: string | null;
  @IsOptional()
  @Expose()
  @IsString()
  email!: string | null;
  @Expose()
  @IsEnum(USER_TYPE)
  userTypeEnum!: USER_TYPE;
  @Expose()
  @IsOptional()
  @IsString()
  password!: string;
  @Expose()
  @IsOptional()
  @IsString()
  phoneNumber?: string | null;
  @Expose()
  @IsOptional()
  @IsNumber()
  officeProfileId?: number | null;
}

export class UserBasicInfoResponse {
  @Expose()
  @Type(() => UserBasicInfo)
  @ValidateNested()
  basicInfo!: UserBasicInfo;
  @Expose()
  @Type(() => UserOfficeProfile)
  @IsArray()
  @ValidateNested()
  userOfficeProfiles!: Array<UserOfficeProfile>;
}
